import { render, staticRenderFns } from "./BackgroundLogin.vue?vue&type=template&id=27bca9f4"
import script from "./BackgroundLogin.vue?vue&type=script&lang=js"
export * from "./BackgroundLogin.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports